export default "__VITE_ASSET__B_svZG4i__"